import * as React from "react";
import { makeStyles, createStyles } from "@material-ui/core";

import { Text, RelodeTheme } from "../../..";

type LegendLabelProps = {
    text: string;
    color: string;
    addMargin?: boolean;
};

const useBarStyles = makeStyles<RelodeTheme, LegendLabelProps>(
    (theme: RelodeTheme) =>
        createStyles({
            legendContainer: {
                display: "flex",
                alignItems: "center",
                marginRight: props =>
                    props.addMargin ? theme.spacing(2) : null,
            },
            bar: {
                height: "18px",
                borderRadius: "2px",
                backgroundColor: props => props.color,
                width: "18px",
                marginRight: theme.spacing(1),
            },
        }),
    { name: "LegendLabel" }
);

export const LegendLabel = (props: LegendLabelProps) => {
    const classes = useBarStyles(props);
    return (
        <div className={classes.legendContainer}>
            <div className={classes.bar} />
            <Text>{props.text}</Text>
        </div>
    );
};
